<template>
  <div class="wrong_info">
     <van-overlay :show="infoShow" @click.stop>
        <div class="msg">{{infoMsg}}</div>
     </van-overlay>
  </div>
</template>

<script>
export default {
   name:"wrong-info",
   props:{
      infoShow:{
         type:Boolean
      },
      infoMsg:{
         type:String
      },
   },
   data() {
      return {

      }
   },
}
</script>

<style lang="scss" scoped>
.van-overlay {
      // display: flex;
      // justify-content: center;
      // align-items: center;
      .msg{
         width:314px;
         height:154px;
         line-height:154px;
         position: absolute;
         left:50%;
         top:50%;
         margin-left:-157px;
         margin-top:-77px;
         z-index:8;
         background: #fff;
         font-size:16px;
         border-radius:16px;
         color:#333;
         font-weight:400;
         text-align: center;
         font-family: PingFangSC-Regular, PingFang SC;
         animation: shake 5s infinite ease-in-out;
      }
      @keyframes shake {
         0%{
            transform: translate(0, 0) rotate(0);
         }
         2%{ 
            transform: translate(6px, -2px) rotate(3.5deg);  
         }  
         4%{  
            transform: translate(5px, 8px) rotate(-0.5deg);  
         }  
         6%{  
            transform: translate(6px, -3px) rotate(-2.5deg);   
         }  
         8%{  
            transform: translate(4px, -2px) rotate(1.5deg);  
         }   
         10%{  
            transform: translate(-6px, 8px) rotate(-1.5deg);  
         }   
         12%{
            transform: translate(-5px, 5px) rotate(1.5deg);  
         } 
         14% {  
            transform: translate(4px, 10px) rotate(3.5deg);  
         }   
         16% {  
            transform: translate(0px, 4px) rotate(1.5deg); 
         }   
         18% {  
            transform: translate(-1px, -6px) rotate(-0.5deg); 
         }   
         20% {  
            transform: translate(6px, -9px) rotate(2.5deg); 
         }  
         22% {  
            transform: translate(1px, -5px) rotate(-1.5deg);  
         }   
         24% { 
             transform: translate(-9px, 6px) rotate(-0.5deg); 
         }   
         26% {  
            transform: translate(8px, -2px) rotate(-1.5deg);   
         }   
         28% {  
            transform: translate(2px, -3px) rotate(-2.5deg);   
         }   
         30%{  
            transform: translate(9px, -7px) rotate(-0.5deg);  
         }   
         32%{
            transform: translate(8px, -6px) rotate(-2.5deg);
         }
         34%{  
            transform: translate(-5px, 1px) rotate(3.5deg);   
         }   
         36%{
            transform: translate(0px, -5px) rotate(2.5deg);
         }
         38%{
            transform: translate(2px, 7px) rotate(-1.5deg);
         }
         40%{
            transform: translate(6px, 3px) rotate(-1.5deg);
         }
         42%{
            transform: translate(1px, -5px) rotate(-1.5deg);
         }
         44%{  transform: translate(10px, -4px) rotate(-0.5deg);   }  
         46% {  transform: translate(-2px, 2px) rotate(3.5deg);   }   
         48% {  transform: translate(3px, 4px) rotate(-0.5deg);   }   
         50% {  transform: translate(8px, 1px) rotate(-1.5deg);   }   
         52% {  transform: translate(7px, 4px) rotate(-1.5deg);   }   
         54% {  transform: translate(10px, 8px) rotate(-1.5deg);   }   
         56% {  transform: translate(-3px, 0px) rotate(-0.5deg);   }   
         58% {  transform: translate(0px, -1px) rotate(1.5deg);   }   
         60% {  transform: translate(6px, 9px) rotate(-1.5deg);   }  
         62% {  transform: translate(-9px, 8px) rotate(0.5deg);   }  
         64% {  transform: translate(-6px, 10px) rotate(0.5deg);   }  
         66% {  transform: translate(7px, 0px) rotate(0.5deg);   }   
         68% {  transform: translate(3px, 8px) rotate(-0.5deg);   }  
         70% {  transform: translate(-2px, -9px) rotate(1.5deg);   }  
         72% {  transform: translate(-6px, 2px) rotate(1.5deg);   }   
         74% {  transform: translate(-2px, 10px) rotate(-1.5deg);   }  
         76% {  transform: translate(2px, 8px) rotate(2.5deg);   }  
         78% {  transform: translate(6px, -2px) rotate(-0.5deg);   }   
         80% {  transform: translate(6px, 8px) rotate(0.5deg);   }  
         82% {  transform: translate(10px, 9px) rotate(3.5deg);   }   
         84% {  transform: translate(-3px, -1px) rotate(3.5deg);   }   
         86% {  transform: translate(1px, 8px) rotate(-2.5deg);   }   
         88% {  transform: translate(-5px, -9px) rotate(2.5deg);   }  
         90% {  transform: translate(2px, 8px) rotate(0.5deg);   }  
         92% {  transform: translate(0px, -1px) rotate(1.5deg);   }  
         94% {  transform: translate(-8px, -1px) rotate(0.5deg);   }   
         96% {  transform: translate(-3px, 8px) rotate(-1.5deg);   }  
         98% {  
            transform: translate(4px, 8px) rotate(0.5deg);   
         }  
         100%{ 
            transform: translate(0, 0) rotate(0);  
         }
      }
   }
</style>